'use es6';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { mapRedirectTargetToRoute } from 'self-service-api/core/utilities/links';
import { SURVEY_OPTIONS_BY_UPGRADE_PRODUCT } from 'ui-addon-upgrades/_core/common/constants/trials';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { navigateTo } from '../../common/navigation/url';
import { shuffle } from '../../../utils';
var LANG_ROUTE = 'upgrades.activationModal';

var TrialRedirectSurvey = function TrialRedirectSurvey(_ref) {
  var upgradeData = _ref.upgradeData,
      upgradeProduct = _ref.upgradeData.upgradeProduct;
  var surveyOptions = useMemo(function () {
    return shuffle(SURVEY_OPTIONS_BY_UPGRADE_PRODUCT[upgradeProduct]);
  }, [upgradeProduct]);

  var handleRedirect = function handleRedirect(value) {
    tracker.trackBeforeUnload('trialActivationRedirected', Object.assign({
      redirectTarget: value
    }, upgradeData));
    navigateTo(mapRedirectTargetToRoute(value, upgradeProduct));
  };

  return React.createElement("div", {
    className: "m-top-6",
    style: {
      width: '100%'
    }
  }, React.createElement("h5", null, React.createElement(FormattedMessage, {
    message: LANG_ROUTE + ".featureExplore"
  })), React.createElement(UIList, null, surveyOptions.map(function (option) {
    return React.createElement(UISelectableButton, {
      className: "m-bottom-2 display-inline-block text-left",
      key: option,
      textLabel: React.createElement(FormattedMessage, {
        message: LANG_ROUTE + ".survey." + option + ".description"
      }),
      block: true,
      name: option,
      truncatable: false,
      onClick: function onClick() {
        return handleRedirect(option);
      }
    });
  }), React.createElement(UISelectableButton, {
    className: "m-bottom-2 display-inline-block text-left",
    textLabel: React.createElement(FormattedMessage, {
      message: LANG_ROUTE + ".survey.other"
    }),
    block: true,
    name: "other",
    truncatable: false,
    onClick: function onClick() {
      return handleRedirect('other');
    }
  })));
};

TrialRedirectSurvey.propTypes = {
  upgradeData: PropTypes.object.isRequired
};
export default TrialRedirectSurvey;